import type { PriceGridFilterState } from './types';

const ALIGN_PRICES_ON_DECIMAL_KEY = 'alignPricesOnDecimal';

export function getAlignPricesOnDecimal(filterState: PriceGridFilterState) {
  return filterState.custom?.[ALIGN_PRICES_ON_DECIMAL_KEY] !== false;
}

export function setAlignPricesOnDecimal(filterState: PriceGridFilterState, enabled: boolean) {
  return {
    ...filterState,
    custom: {
      ...filterState.custom,
      [ALIGN_PRICES_ON_DECIMAL_KEY]: enabled ? undefined : false,
    },
  };
}
